import amRedCross from './american-red-cross.png';

const AmRedCrossLogo = (): JSX.Element => (
    <img alt="American Red Cross" src={amRedCross} />
);

export default AmRedCrossLogo;